import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@accure/ui';
import { Loader2 } from 'lucide-react';

import { WorkstreamQuery } from '@/project-management/queries/workstream.query';

import { EditWorkstreamForm } from './edit-workstream.form';
import type { EditWorkstreamModalOpen } from './edit-workstream.provider';

export type EditWorkstreamModalProps = {
  open: EditWorkstreamModalOpen;
  onClose: () => void;
};

export function EditWorkstreamModal({
  open,
  onClose,
}: EditWorkstreamModalProps) {
  return (
    <Dialog open={Boolean(open)} onOpenChange={onClose}>
      {open ? (
        <EditWorkstreamModalContent id={open.id} onClose={onClose} />
      ) : null}
    </Dialog>
  );
}

type EditWorkstreamModalContentProps = {
  id: string;
  onClose: () => void;
};

function EditWorkstreamModalContent({
  id,
  onClose,
}: EditWorkstreamModalContentProps) {
  const workstreamQuery = WorkstreamQuery.useQuery(
    {
      id: id!, // INFO: Because `enabled: Boolean(id)` we know id won't be undefined
    },
    { enabled: Boolean(id) },
  );

  if (workstreamQuery.isLoading) {
    return (
      <DialogContent className="flex min-h-[350px] items-center justify-center py-8 sm:max-w-sm">
        <Loader2 className="size-8 animate-spin text-gray-300" />
      </DialogContent>
    );
  }

  if (workstreamQuery.isError || !workstreamQuery.data) {
    throw workstreamQuery.error;
  }

  return (
    <DialogContent className="gap-6 sm:max-w-lg">
      <DialogHeader>
        <DialogTitle>Edit Workstream</DialogTitle>
        <p className="text-sm text-gray-600">
          Update workstream details to keep your project information current.
        </p>
      </DialogHeader>
      <EditWorkstreamForm
        workstream={workstreamQuery.data.workstream}
        onClose={onClose}
      />
    </DialogContent>
  );
}
